/* eslint-disable */
/* prettier-ignore-start */
// [GENERATED FILE; DO NOT EDIT BY HAND]

import React from "react"

var element = React.createElement("svg", {
  viewBox: "0 0 24 24",
  fill: "currentColor",
  "aria-hidden": "true",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M12 2c5.519 0 10 4.481 10 10s-4.481 10-10 10S2 17.519 2 12 6.481 2 12 2zm2.781 6.875A3.99 3.99 0 0112.025 10H12a3.989 3.989 0 01-2.717-1.065l-.017-.016-3.502 7.623A7.71 7.71 0 0012 19.714h.029a7.707 7.707 0 006.215-3.183l-3.463-7.656zM12 4.286a1.715 1.715 0 000 3.428h.011a1.715 1.715 0 000-3.428H12z"
}));

var Svg = React.forwardRef(function (props, ref) {
  var next = { ref: ref };
  for (var key in props) {
    if (props.hasOwnProperty(key)) {
      next[key] = props[key];
    }
  }
  return React.cloneElement(element, next);
});
Svg.displayName = "Ultrasound";
Svg.element = element;
export default Svg;
